import { RunSchema } from '@/types/schema';
import { getFlattenedArrayOfGenerations } from '@/utils/messages';

export function getPlaygroundChainOutput(
  run?: RunSchema | null
): RunSchema['outputs'] {
  const initialOutput =
    run?.outputs ?? (run?.outputs?.output as RunSchema['outputs']);
  const generations = getFlattenedArrayOfGenerations(initialOutput);
  const output =
    (generations.length > 0
      ? { output: generations[0].text }
      : initialOutput) ?? {};

  return output;
}
